<template>
    <div class="row">
        <div class="col-10 offset-1" >
            <b-jumbotron bg-variant="light" class="shadow rounded">
                <p class="h1 mb-2 text-info">威化范<b-icon icon="exclamation" variant="info"></b-icon></p>
                <h3 class="text-muted ml-4">
                    伟华的个人博客，记录工作，记录生活
                </h3>
            </b-jumbotron>
        </div> 
    </div>
</template>


<script>
export default {
    name : 'BigTitle',
    props: {
        
    },

    computed: {

    }
}

</script>

<!-- <script type="text/javascript">document.write(unescape("%3Cspan id='cnzz_stat_icon_1278970994'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1278970994%26show%3Dpic1' type='text/javascript'%3E%3C/script%3E"));</script> -->

<style scoped>

</style>